import { RightOutlined } from "@ant-design/icons";
import React from "react";
import InView from "react-intersection-observer";
import { ISectionCSS } from "../../models/interface/ISectionCSS";
import {
  getImageOrVideoPath,
  handleChangeIntersection,
} from "../../shared/helpers";
import "./style.scss";

const SectionCategoryInformation = (props: any) => {
  const { sectionItem, history } = props;

  const colors: ISectionCSS = {
    "--color": sectionItem.color || "#000",
    "--backgroundColor": sectionItem.background_color || "#000",
    "--colorTitle": sectionItem.color_title || "#000",
    "--colorContent": sectionItem.color_content || "#000",
    "--backgroundImage": `url(${getImageOrVideoPath(
      (sectionItem && sectionItem.images) || ""
    )})`,
  };

  const handleClick = (e: any, url: string = "/") => {
    e.preventDefault();
    history.push(url);
  };

  return sectionItem ? (
    <div style={colors} className="kd-section-category">
      <div className="kd-section-category-header">
        <div className="kd-section-category-header-img">
          <img src={getImageOrVideoPath(sectionItem.images)} alt="" />
        </div>
        <div className="kd-section-category-header-content">
          <InView
            triggerOnce
            onChange={(inView, entry) =>
              handleChangeIntersection(inView, entry, "text-to-top-animation")
            }>
            <div className="kd-section-category-header-content-title main-title">
              {sectionItem.title}
            </div>
          </InView>
          <div className="kd-section-category-header-content-sub-img">
            <InView
              triggerOnce
              onChange={(inView, entry) =>
                handleChangeIntersection(inView, entry, "img-animation")
              }>
              <img src={getImageOrVideoPath(sectionItem.sub_images)} alt="" />
            </InView>
          </div>
        </div>
      </div>
      <div className="kd-section-category-body">
        <InView
          triggerOnce
          onChange={(inView, entry) =>
            handleChangeIntersection(inView, entry, "text-to-top-animation")
          }>
          <div className="kd-section-category-body-content main-content">
            {sectionItem.content}
          </div>
        </InView>
        <InView
          triggerOnce
          onChange={(inView, entry) =>
            handleChangeIntersection(inView, entry, "text-to-top-animation")
          }>
          <div className="kd-section-actions kd-section-category-body-actions main-content">
            <a onClick={(e: any) => handleClick(e, sectionItem.url)}>
              Chi tiết <RightOutlined style={{ fontSize: 10 }} />
            </a>
            <a onClick={(e: any) => handleClick(e, sectionItem.url_products)}>
              Mua ngay <RightOutlined style={{ fontSize: 10 }} />
            </a>
          </div>
        </InView>
      </div>
    </div>
  ) : null;
};

export default SectionCategoryInformation;
